/**
 * Design tokens for the editorial resume site (IMPLEMENTATION_PLAN.md v2).
 * Paper base, ink bookends, one pink accent, muted pastels on card artifacts only.
 */

export const color = {
  paper: "#F4F0E8",
  ink: "#0E0E0C",
  accent: "#FCAEEA",
  // Muted text on paper — dark enough for 4.5:1 body contrast.
  muted: "#6F6A60",
  // Muted text on ink sections.
  mutedOnInk: "#A8A399",
  // Hairlines on paper.
  line: "rgba(14, 14, 12, 0.14)",
  lineOnInk: "rgba(244, 240, 232, 0.18)",
  pastel: {
    lavender: "#DDD3F1",
    blush: "#F6D9E8",
    sand: "#F0DDBC",
    sage: "#D6E4D2",
    sky: "#CFE3EF",
  },
} as const;

export type PastelName = keyof typeof color.pastel;

export const font = {
  /** Condensed display — one weight, all impact. */
  display: `"Anton", "Arial Narrow", sans-serif`,
  body: `"Bricolage Grotesque", "Helvetica Neue", sans-serif`,
  mono: `"JetBrains Mono", "SFMono-Regular", monospace`,
} as const;

export const layout = {
  maxWidth: "1360px",
  gutter: "clamp(20px, 5vw, 72px)",
  /** Vertical breathing room between sections — one idea per viewport. */
  sectionGap: "clamp(120px, 22vh, 240px)",
} as const;

export const type = {
  /** Giant one/two-word titles that fill the viewport width. */
  display: "clamp(60px, 11.5vw, 168px)",
  /** Large section titles. */
  title: "clamp(40px, 6vw, 92px)",
  /** Two-tone section statements. */
  statement: "clamp(20px, 2.1vw, 27px)",
  body: "16px",
  small: "14px",
  mono: "12.5px",
} as const;

export const ease = {
  /** ease-out-expo-ish — entrances. */
  out: [0.16, 1, 0.3, 1] as [number, number, number, number],
} as const;

export const shadow = {
  /** Tiny + soft, cards only. */
  card: "0 1px 2px rgba(14,14,12,0.05), 0 14px 40px rgba(14,14,12,0.08)",
} as const;

export const z = {
  nav: 40,
  content: 1,
} as const;
